import React from "react";

const ExamPanel = ({
  exams,
  subjects,
  subjectContent,
  expandedExams,
  loading,
  onToggleExam,
  onAddExam,
  onEditExam,
  onDeleteExam,
  onLinkSubjects
}) => {
  if (loading && exams.length === 0) {
    return (
      <div className="col-12">
        <div className="bg-white rounded-12 p-40 text-center">
          <div className="spinner"></div>
          <p className="text-14 text-light-1 mt-20">Loading exams...</p>
        </div>
      </div>
    );
  }

  if (exams.length === 0) {
    return (
      <div className="col-12">
        <div className="bg-white rounded-12 p-40 text-center">
          <i className="icon-graduation-cap text-60 text-light-3 mb-20"></i>
          <h5 className="text-18 fw-500 mb-10">No Exams Yet</h5>
          <p className="text-14 text-light-1 mb-30">
            Create an exam and link subjects to it with pricing. Subjects can belong to multiple exams with different prices.
          </p>
          <button 
            onClick={onAddExam}
            className="button -md bg-purple-1 text-white fw-500"
          >
            <i className="icon-plus mr-10"></i>
            Create First Exam
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="col-12">
      <div className="bg-white rounded-12 p-20">
        <div className="d-flex items-center justify-between mb-20">
          <div>
            <h5 className="text-16 fw-500">All Exams</h5>
            <p className="text-13 text-light-1 mt-5">
              Create exams and link subjects with pricing. Each subject can have different prices for different exams.
            </p>
          </div>
          <button 
            onClick={onAddExam}
            className="button -sm bg-purple-1 text-white"
          >
            <i className="icon-plus mr-8"></i>
            Add Exam
          </button>
        </div>

        <div className="exams-list">
          {exams.map((exam) => {
            const isExpanded = expandedExams.has(exam._id);
            const examSubjects = subjects.filter(s => 
              s.exams && s.exams.some(e => (e._id || e) === exam._id)
            );
            const subjectCount = examSubjects.length;

            return (
              <div key={exam._id} className="exam-card bg-light-5 rounded-8 mb-15 border border-light-3">
                {/* Exam Header */}
                <div 
                  className="d-flex items-center justify-between px-20 py-15 cursor-pointer hover:bg-white transition-all rounded-8"
                  onClick={() => onToggleExam(exam._id)}
                >
                  <div className="d-flex items-center flex-1">
                    <div className="d-flex items-center mr-15">
                      <i className={`text-14 ${isExpanded ? 'icon-chevron-down' : 'icon-chevron-right'} text-light-1 mr-10`}></i>
                      <div 
                        className="size-40 d-flex justify-center items-center rounded-8 mr-15"
                        style={{backgroundColor: exam.color + '20', color: exam.color}}
                      >
                        <i className={`text-16 ${exam.icon || 'icon-graduation-cap'}`}></i>
                      </div>
                    </div>
                    <div className="flex-1">
                      <div className="d-flex items-center x-gap-10 mb-5">
                        <h6 className="text-15 fw-500">{exam.title}</h6>
                        {exam.isFree && (
                          <span className="badge bg-green-1 text-green fw-600" style={{ fontSize: '12px', padding: '4px 10px', borderRadius: '12px' }}>
                            Free
                          </span>
                        )}
                        {exam.isPurchasable && !exam.isFree && (
                          <div className="d-flex items-center x-gap-5">
                            <span className="fw-700" style={{ 
                              fontSize: '16px', 
                              color: '#059669',
                              letterSpacing: '0.3px'
                            }}>
                              ₹{exam.discountPrice || exam.price}
                            </span>
                            {exam.discountPrice && exam.discountPrice < exam.price && (
                              <span className="text-light-3 line-through" style={{ fontSize: '13px' }}>
                                ₹{exam.price}
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                      <div className="text-12 text-light-1">
                        {exam.description || 'No description'}
                      </div>
                      <div className="d-flex items-center x-gap-15 mt-8">
                        <span className="text-11 text-light-2">
                          <i className="icon-book mr-5"></i>
                          {subjectCount} subject{subjectCount !== 1 ? 's' : ''}
                        </span>
                      </div>
                    </div>
                  </div>
                  
                  {/* Action Menu */}
                  <div className="d-flex items-center" style={{ gap: '10px' }}>
                    <button 
                      onClick={(e) => { e.stopPropagation(); onLinkSubjects(exam); }}
                      className="button -sm fw-500"
                      title="Link subjects"
                      style={{
                        padding: '8px 12px',
                        borderRadius: '8px',
                        border: 'none',
                        cursor: 'pointer',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'all 0.2s',
                        fontSize: '13px',
                        minWidth: '40px',
                        backgroundColor: '#3b82f6',
                        color: '#ffffff',
                        boxShadow: '0 1px 3px rgba(59, 130, 246, 0.2)',
                        marginRight: '10px'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#2563eb';
                        e.currentTarget.style.transform = 'translateY(-1px)';
                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(59, 130, 246, 0.3)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#3b82f6';
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 1px 3px rgba(59, 130, 246, 0.2)';
                      }}
                    >

<i className="fa fa-link" aria-hidden="true" style={{ fontSize: '16px' }}></i>
                    </button>
                    <button 
                      onClick={(e) => { e.stopPropagation(); onEditExam(exam); }}
                      className="button -sm fw-500"
                      title="Edit exam"
                      style={{
                        padding: '8px 12px',
                        borderRadius: '8px',
                        border: 'none',
                        cursor: 'pointer',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'all 0.2s',
                        fontSize: '13px',
                        minWidth: '40px',
                        backgroundColor: '#10b981',
                        color: '#ffffff',
                        boxShadow: '0 1px 3px rgba(16, 185, 129, 0.2)',
                        marginRight: '10px'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#059669';
                        e.currentTarget.style.transform = 'translateY(-1px)';
                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(16, 185, 129, 0.3)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#10b981';
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 1px 3px rgba(16, 185, 129, 0.2)';
                      }}
                    >
                      <i className="icon-edit"></i>
                    </button>
                    <button 
                      onClick={(e) => { e.stopPropagation(); onDeleteExam(exam._id); }}
                      className="button -sm fw-500"
                      title="Delete exam"
                      style={{
                        padding: '8px 12px',
                        borderRadius: '8px',
                        border: 'none',
                        cursor: 'pointer',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'all 0.2s',
                        fontSize: '13px',
                        minWidth: '40px',
                        backgroundColor: '#ef4444',
                        color: '#ffffff',
                        boxShadow: '0 1px 3px rgba(239, 68, 68, 0.2)'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#dc2626';
                        e.currentTarget.style.transform = 'translateY(-1px)';
                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(239, 68, 68, 0.3)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#ef4444';
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 1px 3px rgba(239, 68, 68, 0.2)';
                      }}
                    >
                      <i className="icon-bin"></i>
                    </button>
                  </div>
                </div>

                {/* Expanded Content */}
                {isExpanded && (
                  <div className="px-20 pb-20 pt-0">
                    <div className="border-top border-light-3 pt-20 mt-15">
                      {subjectCount === 0 ? (
                        <div className="text-center py-30">
                          <i className="icon-link text-30 text-light-3 mb-10"></i>
                          <p className="text-13 text-light-2 mb-20">
                            No subjects linked yet. Click "Link Subjects" to add subjects with pricing.
                          </p>
                          <button 
                            onClick={(e) => { e.stopPropagation(); onLinkSubjects(exam); }}
                            className="button -sm bg-blue-1 text-blue"
                          >
                            <i className="icon-link mr-8"></i>
                            Link Subjects Now
                          </button>
                        </div>
                      ) : (
                        <div>
                          <h6 className="text-14 fw-500 mb-15">Linked Subjects ({subjectCount})</h6>
                          <div 
                            className="subjects-grid"
                            style={{
                              display: 'grid',
                              gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
                              gap: '15px'
                            }}
                          >
                            {examSubjects.map((subject) => {
                              const pricing = subject.examPricing?.find(p => 
                                (p.exam?._id || p.exam) === exam._id
                              );
                              const effectivePrice = pricing?.discountPrice || pricing?.price || 0;
                              const content = subjectContent[subject._id];
                              const videoCount = content?.videos?.length || 0;
                              const materialCount = content?.pdfs?.length || 0;
                              const testCount = content?.mockTests?.length || 0;
                              
                              return (
                                <div 
                                  key={subject._id} 
                                  className="subject-link-card bg-white rounded-8 border border-light-3"
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'flex-start',
                                    padding: '15px',
                                    transition: 'all 0.2s',
                                    cursor: 'pointer'
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                                    e.currentTarget.style.backgroundColor = '#f8f9fa';
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = 'none';
                                    e.currentTarget.style.backgroundColor = '#ffffff';
                                  }}
                                >
                                  <div 
                                    className="size-30 d-flex justify-center items-center rounded-6 mr-15"
                                    style={{backgroundColor: subject.color + '20', color: subject.color, flexShrink: 0}}
                                  >
                                    <i className={`text-12 ${subject.icon || 'icon-book'}`}></i>
                                  </div>
                                  <div className="flex-1 min-w-0">
                                    <div className="text-13 fw-500 mb-3" style={{ color: '#1e293b' }}>{subject.title}</div>
                                    {subject.description && (
                                      <div className="text-11 text-light-2 mb-3" style={{
                                        display: '-webkit-box',
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: 'vertical',
                                        overflow: 'hidden',
                                        lineHeight: '1.4'
                                      }}>
                                        {subject.description}
                                      </div>
                                    )}
                                    {pricing ? (
                                      <div className="text-11 mb-3">
                                        {pricing.isFree ? (
                                          <span className="text-green fw-500">Free</span>
                                        ) : (
                                          <div className="d-flex items-center x-gap-5">
                                            <span className="fw-600" style={{ color: '#059669' }}>
                                              ₹{effectivePrice}
                                            </span>
                                            {pricing.discountPrice && pricing.discountPrice < pricing.price && (
                                              <span className="text-light-3 line-through text-10">
                                                ₹{pricing.price}
                                              </span>
                                            )}
                                          </div>
                                        )}
                                      </div>
                                    ) : (
                                      <div className="mb-3">
                                        <span className="badge bg-yellow-1 text-yellow text-10" style={{ padding: '2px 6px', borderRadius: '8px' }}>
                                          No pricing
                                        </span>
                                      </div>
                                    )}
                                    <div className="d-flex items-center x-gap-10 text-10 text-light-2">
                                      <span>
                                        <i className="icon-play-circle text-blue mr-3"></i>
                                        {videoCount} videos
                                      </span>
                                      <span>
                                        <i className="icon-file-text text-green mr-3"></i>
                                        {materialCount} materials
                                      </span>
                                      <span>
                                        <i className="icon-clipboard-check text-orange mr-3"></i>
                                        {testCount} tests
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ExamPanel;

